export default {
    indexEventPublics:         { method: 'get',    url: 'event_publics' },
    createEventPublic:         { method: 'post',   url: 'event_publics' },
    updateEventPublic:         { method: 'put',    url: 'event_publics/{id}' },
    destroyEventPublic:        { method: 'delete', url: 'event_publics/{id}' },
}